import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tooltip", "tooltipOpen"];
import styled from 'foundations-theming/utils';
import { Tooltip } from '../Tooltip/Tooltip';
import { getFocusStyleObject } from '../../utils/focus/focus.style';
import { jsx as _jsx } from "react/jsx-runtime";
const disableMixin = theme => {
  return {
    '::after': {
      content: '""',
      display: 'inline-block',
      position: 'absolute',
      top: theme.space[300],
      bottom: theme.space[0],
      left: theme.space[50],
      right: theme.space[300],
      borderTopWidth: theme.borderWidth[100],
      borderTopStyle: 'solid',
      borderTopColor: 'currentcolor',
      transform: 'rotate(45deg)'
    }
  };
};
const Cell = styled.td.withConfig({
  displayName: "Day__Cell",
  componentId: "dy9vtv-0"
})(({
  $isDisabled,
  $isSelected,
  $isToday,
  $isCurrentMonth,
  $isInRange,
  $isRangeStart,
  $isRangeEnd,
  theme
}) => {
  return Object.assign({
    position: 'relative',
    blockSize: '32px',
    padding: 0,
    cursor: $isDisabled ? 'not-allowed' : 'pointer',
    color: $isDisabled ? theme.color['text-core-disabled'] : $isSelected ? theme.color['text-primary-default'] : !$isCurrentMonth ? theme.color['text-core-disabled'] : $isToday ? theme.color['text-brand-default'] : '',
    backgroundColor: $isDisabled ? '' : $isSelected ? theme.color['icon-interactive-default'] : $isInRange ? theme.color['fill-field-hover'] : '',
    borderRadius: $isInRange ? '' : $isRangeStart && $isRangeEnd ? theme.borderRadius['100'] : $isRangeStart ? `${theme.borderRadius['100']} 0 0 ${theme.borderRadius['100']}` : $isRangeEnd ? `0 ${theme.borderRadius['100']} ${theme.borderRadius['100']} 0` : theme.borderRadius['100'],
    fontWeight: $isSelected || $isToday ? theme.typography['heading-300'].fontWeight : theme.typography['heading-400'].fontWeight
  }, $isDisabled && disableMixin(theme), getFocusStyleObject({
    theme,
    addBorderRadius: true
  }), {
    '&:before': {
      content: $isToday ? '""' : undefined,
      display: $isToday ? 'inline-block' : undefined,
      position: $isToday ? 'absolute' : undefined,
      border: $isToday ? `${theme.borderWidth[200]} solid` : undefined,
      borderColor: $isDisabled ? theme.color['text-core-disabled'] : $isToday && $isSelected ? theme.color['icon-primary-default'] : $isToday ? theme.color['fill-brand-default'] : undefined,
      top: $isToday ? theme.space[600] : undefined,
      left: $isToday ? theme.space[400] : undefined,
      borderRadius: $isToday ? '50%' : undefined
    },
    '&:hover': {
      backgroundColor: !$isDisabled && !$isSelected && $isInRange ? theme.color['fill-transitional-field-hover'] : $isDisabled ? undefined : $isSelected ? theme.color['icon-interactive-default'] : theme.color['fill-field-hover'],
      color: $isDisabled || !$isCurrentMonth ? theme.color['text-core-disabled'] : $isSelected ? theme.color['text-primary-default'] : $isToday ? theme.color['text-brand-default'] : theme.color['text-core-default']
    }
  });
});
export const Day = _ref => {
  let {
      tooltip,
      tooltipOpen
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isDisabled,
    isSelected,
    isToday,
    isCurrentMonth,
    isInRange,
    isRangeStart,
    isRangeEnd
  } = rest;
  return /*#__PURE__*/_jsx(Tooltip, {
    "aria-live": "polite",
    open: tooltipOpen,
    title: tooltip,
    children: /*#__PURE__*/_jsx(Cell, Object.assign({
      $isDisabled: isDisabled,
      $isSelected: isSelected,
      $isToday: isToday,
      $isCurrentMonth: isCurrentMonth,
      $isInRange: isInRange,
      $isRangeStart: isRangeStart,
      $isRangeEnd: isRangeEnd,
      tabIndex: isDisabled ? undefined : 0
    }, rest))
  });
};